/**
 * Message Type that can be sent to a ChargePoint
 */
export enum UpdateType {
    DIFFERENTIAL = 'DIFFERENTIAL',
    FULL = 'FULL'
}
